<template>
  <v-container class="pa-0" fluid>
    <v-card>
      <v-layout wrap class="card-bg-2">
        <v-flex xs12 md5 data-ui-component="specimena-list" CLASS="divider-right">
          <v-card-title class="headline pb-2 specimen-info-card--title">
            Plot Specimena
            <v-spacer />
            <v-text-field v-model="search" label="Search" prepend-inner-icon="search" class="rounded font-weight-regular" hide-details clearable solo placeholder="Search specimen">
            </v-text-field>
          </v-card-title>
          <v-divider />
          <v-data-table :items="plotDataSource.Specimena" :headers="specimenTableHeaders" :search="search" :rows-per-page-items="specimenTableRowsPerPage">
            <template v-slot:items="props">
              <tr class="clickable" :active="isSelectedSpecimen(props.item)" @click="toggleSpecimen(props.item)">
                <td>
                  <v-radio-group hide-details :value="isSelectedSpecimen(props.item)">
                    <v-radio @click.prevent color="info" hide-details :value="true" />
                  </v-radio-group>
                </td>
                <td>{{ props.item.ImportedSpeciesId }}</td>
                <td>{{ props.item.SpeciesCommonName }}</td>
                <td>{{ props.item.SpeciesFullLatinName }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <v-flex xs12 md7 data-ui-component="specimena-metadata" class="divider-left">
          <v-card-title class="headline pb-2 specimen-info-card--title">Information</v-card-title>
          <v-divider />
          <v-data-table :headers="informationTableHeaders" :items="specimenInformation" disable-initial-sort hide-headers hide-actions class="elevation-1">
            <template v-slot:items="{ item, index}">
              <tr :class="{ alternate: index % 2 == 0 }">
                <td class="text-xs-left font-weight-medium">{{ item.Field}}</td>
                <td class="text-xs-left">{{item.FieldValue}}</td>
              </tr>
            </template>
            <template v-slot:no-data>
              <div class="pa-4 text-xs-center">
                <v-icon color="warning" large>filter_vintage</v-icon>
                <br />
                Please select a specimen
              </div>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-card>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import {
    prettyDateFormat,
  } from '@/components/mixins/MomentUtil'
  import {
    min,
    max,
  } from 'date-fns'


  import {
    calculateDisplayValue,
  } from '@/helpers/kvValueHelper'
  export default {
    props: {
      value: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        search: '',
        selectedSpecimen: null,
        specimenTableHeaders: [{
          text: '',
          align: '',
          value: 'select',
          sortable: false,
        },
        {
          text: 'Id',
          align: 'left',
          value: 'ImportedSpeciesId',
        },
        {
          text: 'Common Name',
          align: 'left',
          value: 'SpeciesCommonName',
        },
        {
          text: 'Latin Name',
          align: 'left',
          value: 'SpeciesFullLatinName',
        },
        ],
        informationTableHeaders: [{
          text: 'Field',
          value: 'Field',
        },
        {
          text: 'Value',
          value: 'Value',
        },
        ],
      }
    },
    computed: {
      plotDataSource() {
        return this.value
      },
      specimenInformation() {
        if (this.selectedSpecimen == null) {
          return []
        }

        let specimenData = [{
          Field: 'Id',
          FieldValue: this.selectedSpecimen.ImportedSpeciesId,
        },
        {
          Field: 'Common Name',
          FieldValue: this.selectedSpecimen.SpeciesCommonName,
        },
        {
          Field: 'Latin Name',
          FieldValue: this.selectedSpecimen.SpeciesFullLatinName,
        },
          ...this.calculateSpecimenSurveySummary(this.selectedSpecimen),
        ]
        let kvStore = this.selectedSpecimen.Metadata.Data
        let metadata = Object.keys(kvStore).map(key => ({
          Field: key,
          FieldValue: calculateDisplayValue(kvStore[key]),
        }))
        return [
          ...specimenData,
          ...metadata,
        ]
      },
      specimenTableRowsPerPage() {
        return [25, 50, {
          'text': '$vuetify.dataIterator.rowsPerPageAll',
          'value': -1,
        }]
      },
    },
    methods: {
      isSelectedSpecimen(specimen) {
        if (this.selectedSpecimen == null) {
          return false
        }
        return this.selectedSpecimen.Id == specimen.Id
      },
      toggleSpecimen(specimen) {
        if (this.selectedSpecimen != null && this.selectedSpecimen.Id == specimen.Id) {
          this.selectedSpecimen = null
        } else {
          this.selectedSpecimen = specimen
        }
      },
      calculateSpecimenSurveySummary(specimen) {
        let summary = []
        if (specimen && specimen.Surveys) {
          let surveyDates = specimen.Surveys.map(x => x.SurveyDateTimeRaw)
          let firstSurveyDate = min(...surveyDates)
          let lastSurveyDate = max(...surveyDates)
          if (surveyDates.length > 0 && firstSurveyDate && lastSurveyDate) {
            summary.push({
              Field: 'Number of Surveys',
              FieldValue: surveyDates.length,
            })
            summary.push({
              Field: 'First Survey Date',
              FieldValue: moment(firstSurveyDate).format(prettyDateFormat),
            })
            summary.push({
              Field: 'Last Survey Date',
              FieldValue: moment(lastSurveyDate).format(prettyDateFormat),
            })
          }
        }
        return summary
      },
    },
  }
</script>
<style scoped>
  .specimen-info-card--title {
    height: 100px;
  }
</style>